export const REQUEST_SIGN_UP_VERIFY = 'REQUEST_SIGN_UP_VERIFY'
export const RECEIVE_SIGN_UP_VERIFY = 'RECEIVE_SIGN_UP_VERIFY'

export const REQUEST_SIGN_IN = 'REQUEST_SIGN_IN'
export const RECEIVE_SIGN_IN = 'RECEIVE_SIGN_IN'
export const RESET_SIGN_IN = 'RESET_SIGN_IN'

export const REQUEST_SIGN_IN_PROTOCOL = 'REQUEST_SIGN_IN_PROTOCOL'
export const RECEIVE_SIGN_IN_PROTOCOL = 'RECEIVE_SIGN_IN_PROTOCOL'
export const RESET_SIGN_IN_PROTOCOL = 'RESET_SIGN_IN_PROTOCOL'

export const REQUEST_SIGN_IN_VALIDATE_DOC = 'REQUEST_SIGN_IN_VALIDATE_DOC'
export const RECEIVE_SIGN_IN_VALIDATE_DOC = 'RECEIVE_SIGN_IN_VALIDATE_DOC'
export const RESET_SIGN_IN_VALIDATE_DOC = 'RESET_SIGN_IN_VALIDATE_DOC'

export const REQUEST_SIGN_UP = 'REQUEST_SIGN_UP'
export const RECEIVE_SIGN_UP = 'RECEIVE_SIGN_UP'
export const RESET_SIGN_UP = 'RESET_SIGN_UP'

export const REQUEST_PLANS = 'REQUEST_PLANS'
export const RECEIVE_PLANS = 'RECEIVE_PLANS'

export const REQUEST_PLAN = 'REQUEST_PLAN'
export const RECEIVE_PLAN = 'RECEIVE_PLAN'
export const RESET_PLAN = 'RESET_PLAN'

export const REQUEST_SIGN_UP_MEDICO = 'REQUEST_SIGN_UP_MEDICO'
export const RECEIVE_SIGN_UP_MEDICO = 'RECEIVE_SIGN_UP_MEDICO'
export const RESET_SIGN_UP_MEDICO = 'RESET_SIGN_UP_MEDICO'

export const REQUEST_RECOVERY_PASSWD = 'REQUEST_RECOVERY_PASSWD'
export const RECEIVE_RECOVERY_PASSWD = 'RECEIVE_RECOVERY_PASSWD'
export const RESET_RECOVERY_PASSWD = 'RESET_RECOVERY_PASSWD'

export const REQUEST_CHANGE_PASSWD = 'REQUEST_CHANGE_PASSWD'
export const RECEIVE_CHANGE_PASSWD = 'RECEIVE_CHANGE_PASSWD'

export const REQUEST_CHANGE_EMAIL = 'REQUEST_CHANGE_EMAIL'
export const RECEIVE_CHANGE_EMAIL = 'RECEIVE_CHANGE_EMAIL'

export const REQUEST_CHANGE_PHONE = 'REQUEST_CHANGE_PHONE'
export const RECEIVE_CHANGE_PHONE = 'RECEIVE_CHANGE_PHONE'
